import { Select } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { useEffect, useState } from 'react';

import { getBookPublishers } from '@/entities/books/api/books-api';
import { Book, BookPublishers } from '@/entities/books/model/types';

type Props = {
  setBookInfo: React.Dispatch<React.SetStateAction<Book>>;
  form: UseFormReturnType<Book>;
};

export const BookPublishersSelect = ({ form, setBookInfo }: Props) => {
  const [publishersData, setPublishersData] = useState<BookPublishers[]>([]);

  useEffect(() => {
    const fetchPublishers = async () => {
      try {
        const { publishers } = await getBookPublishers();
        setPublishersData(publishers);
      } catch (error) {
        console.error('Ошибка при загрузке списка издательств', error);
      }
    };

    fetchPublishers();
  }, []);

  const publisherOptions = publishersData?.map((publisher) => ({
    value: String(publisher.id),
    label: publisher.title,
  }));

  const handlePublisherChange = (value: string | null) => {
    form.setFieldValue('publisherId', Number(value));
    setBookInfo((prev) => ({
      ...prev,
      publisherId: Number(value),
    }));
  };

  return (
    <Select
      mb={20}
      label="Издательство"
      key={form.key('publisherId')}
      placeholder="Выберите издательство"
      data={publisherOptions}
      value={String(form.values.publisherId)}
      onChange={handlePublisherChange}
    />
  );
};
